import { EventHandler, MouseEvent, useState } from 'react'
import { ClickAwayListener } from '@mui/base/ClickAwayListener'
import { IColorByValueConfig } from 'app/services/api/colorByValue'
import useInitCBVConfigEffect from './utils/useInitCBVConfigEffect'
import Button from './Button'
import Dropdown from './Dropdown'
import ColorByValueCustomizeColorModal from './Modal'

interface IColorByValueComponent {
  config: IColorByValueConfig | undefined
  setConfig: React.Dispatch<
    React.SetStateAction<IColorByValueConfig | undefined>
  >
}

const ColorByValue = ({ config, setConfig }: IColorByValueComponent) => {
  const [dropdownAnchorEl, setDropdownAnchorEl] = useState<Element | null>(null)
  const [isCustomizeModalOpen, setIsCustomizeModalOpen] = useState(false)
  const [isModalLoading, setIsModalLoading] = useState(false)

  useInitCBVConfigEffect({ config, setConfig })

  const handleToolbarToggleClick: EventHandler<MouseEvent> = (
    evt: MouseEvent | TouchEvent
  ): void => {
    setDropdownAnchorEl(
      dropdownAnchorEl != null ? null : (evt.currentTarget as Element)
    )
  }

  const handleCustomizeColorsButton = () => {
    setIsCustomizeModalOpen(!isCustomizeModalOpen)
    setDropdownAnchorEl(null)
  }

  const handleClickAway = (): void => {
    if (dropdownAnchorEl != null) {
      setDropdownAnchorEl(null)
    }
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <Button onClick={handleToolbarToggleClick} />
        <Dropdown
          anchorEl={dropdownAnchorEl}
          config={config}
          setAnchorEl={setDropdownAnchorEl}
          customizeColorsCB={handleCustomizeColorsButton}
          isCBVLoading={isModalLoading}
          setIsCBVLoading={setIsModalLoading}
        />
        {config != null && (
          <ColorByValueCustomizeColorModal
            config={config}
            isModalOpen={isCustomizeModalOpen}
            setIsModalOpen={setIsCustomizeModalOpen}
            isModalLoading={isModalLoading}
            setIsModalLoading={setIsModalLoading}
          />
        )}
      </div>
    </ClickAwayListener>
  )
}

export default ColorByValue
